export const SCHOOL_GET_MULTIPLE =  "SCHOOL_GET_MULTIPLE"
export const SCHOOL_GET_DROPDOWNS =  "SCHOOL_GET_DROPDOWNS"
export const SCHOOL_GET_ONE =  "SCHOOL_GET_ONE"
export const SCHOOL_REGISTER_SUCCESS =  "SCHOOL_REGISTER_SUCCESS"
export const SCHOOL_REGISTER_FAIL =  "SCHOOL_REGISTER_FAIL"
export const SCHOOL_LOADING =  "SCHOOL_LOADING"
export const SCHOOL_LOADING_ERROR =  "SCHOOL_LOADING_ERROR"
export const SCHOOL_ACTIVATE_FAIL =  "SCHOOL_ACTIVATE_FAIL"
export const SCHOOL_ACTIVATE_SUCCESS =  "SCHOOL_ACTIVATE_SUCCESS"
export const SCHOOL_UPDATE_SUCCESS =  "SCHOOL_UPDATE_SUCCESS"
export const SCHOOL_UPDATE_FAIL =  "SCHOOL_UPDATE_FAIL"
export const SCHOOL_DELETE_SUCCESS =  "SCHOOL_DELETE_SUCCESS"
export const SCHOOL_DELETE_FAIL =  "SCHOOL_DELETE_FAIL"
export const SCHOOL_EDIT =  "SCHOOL_EDIT"